import React from 'react';
import { getDocumentPreviewKind } from '../utils/documentFormatters';
import PreviewFallbackIcon from './PreviewFallbackIcon';

const DocumentPreview = ({ document }) => {
  const previewKind = getDocumentPreviewKind(document);

  if (previewKind === 'image') {
    return (
      <img
        src={document.url}
        alt={document.filename}
        className="tw-h-full tw-w-full tw-object-cover"
      />
    );
  }

  if (previewKind === 'pdf') {
    return (
      <iframe
        src={document.url}
        title={document.filename}
        className="tw-h-full tw-w-full"
      />
    );
  }

  return <PreviewFallbackIcon filename={document.filename} />;
};

export default DocumentPreview;
